import { WorkspaceMinimalFragment } from '@sketch/gql-types'
import useWelcomeModal from './useWelcomeModal'

export interface WelcomeModalTriggerProps {
  workspace: WorkspaceMinimalFragment
}

export const WelcomeModalTrigger = (props: WelcomeModalTriggerProps) => {
  const { workspace } = props
  useWelcomeModal(workspace)

  return null
}
